import HollowButton from './HollowButton';

export default HollowButton;
